
import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import Swal from 'sweetalert2'

import history from '../../Helpers/History'
import useTranslation from '../../Hooks/UseTranslation'

import SessionActions from '../../Redux/Actions/SessionActions'

import InputFormControl from '../../Components/InputFormControl/InputFormControl'
import TopLoader from '../../Components/TopLoader/TopLoader'

import AuthLayout from '../../Layouts/AuthLayout/AuthLayout'

const ForgotPage = (props: any) => {

    const { t } = useTranslation()

    const requestRecoveryStatus = useSelector((state: any) => state.SessionReducer.requestRecoveryStatus)
    const dispatch = useDispatch()

    const [ email, setEmail ] = useState('')

    if (requestRecoveryStatus === 'requested') {

        Swal.fire({
            title: t('FORGOT_PASSWORD:RequestSentTitle'),
            text: t('FORGOT_PASSWORD:RequestSentContent'),
            icon: 'success',
            confirmButtonText: t('FORGOT_PASSWORD:RequestSentCloseButton'),
            width: '500px',
            onClose: () => history.push('/login')
        })
    }

    const requestRecovery = () => {

        dispatch(SessionActions.requestRecoveryAction(email))
    }

    return (
        <AuthLayout>
            <div className="card 0-hidden">
                <div className="row">
                    <div className="col-md-12 text-center">
                        <div className="p-4">
                            <div className="logo text-center mb-4">
                                <img src="/images/logo.svg" alt=""/>
                            </div>
                            <div>
                                <h1 className="h1-title mb-1 text-14">
                                    {t('FORGOT_PASSWORD:ForgotPassword-title')}
                                </h1>

                                <div>
                                    <div className="form-group">
                                        <InputFormControl
                                            type="email"
                                            className="form-control"
                                            placeholder={t('FORGOT_PASSWORD:Placeholder-Email')}
                                            value={email}
                                            onChange={(value: string) => setEmail(value)}
                                            autoFocus
                                        />
                                        {/* <span id="errorUsername" className="error-message">{emailError}</span> */}
                                    </div>
                                    <button
                                        className="btn btn-block mt-2 btn-handle-recover"
                                        onClick={() => requestRecovery()}
                                    >
                                        Enviar
                                    </button>
                                </div>
                                <div className="mt-3 text-center">
                                    <Link to="/login" className="btn btn-light btn-block">
                                        <u>
                                            {t('FORGOT_PASSWORD:LoginButton')}
                                        </u>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <TopLoader show={requestRecoveryStatus === 'requesting'} />
        </AuthLayout>
    )
}

export default ForgotPage
